import React from "react";
import '../css/home.css';
import { Helmet } from "react-helmet";
import { FaCarCrash, FaFileAlt, FaBan, FaExclamationTriangle, FaWineBottle, FaKey } from "react-icons/fa";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faWaze, faWhatsapp} from '@fortawesome/free-brands-svg-icons';
import {Facebook } from 'lucide-react';
import { useState,useEffect } from 'react';
import { FaUserTie, FaGavel, FaCarSide } from "react-icons/fa";

const logo = require('../pictures/logoBeni.jpg');
const pic = require('../pictures/picBeni.jpg');

export default function Home() {

    const [formData, setFormData] = useState({ name: "", phone: "", email: "", message: "" });
    const [errors, setErrors] = useState({});
    const [successMsg, setSuccessMsg] = useState("");
    const [captchaReady, setCaptchaReady] = useState(false);

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://www.google.com/recaptcha/api.js?render=6LfU1d4rAAAAAID9Q591IVVAvhK6rKLBElmaKjGA";
        script.async = true;
        script.onload = () => setCaptchaReady(true);
        document.body.appendChild(script);
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.name.trim()) newErrors.name = "אנא הזן שם מלא";
        if (!formData.phone.trim()) newErrors.phone = "אנא הזן מספר טלפון";
        else if (!/^\d{7,15}$/.test(formData.phone.replace(/[-\s]/g, ''))) newErrors.phone = "מספר טלפון לא תקין";
        if (!formData.email.trim()) newErrors.email = "אנא הזן אימייל";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = "אימייל לא תקין";
        if (!formData.message.trim()) newErrors.message = "אנא הזן הודעה";
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setErrors({});

        if (!captchaReady) {
            setErrors({ form: "Captcha עדיין לא טעון, נסה שנית" });
            return;
        }

        try {
            const token = await window.grecaptcha.execute("6LfU1d4rAAAAAID9Q591IVVAvhK6rKLBElmaKjGA", { action: "submit" });

            //const response = await fetch(`${process.env.REACT_APP_API_URL}/mail`, { // development
            const res = await fetch('/mail', {// production
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ...formData, captchaToken: token }),
            });

            const data = await res.json();
            if (!res.ok) throw new Error(data.message);
            setSuccessMsg(data.message);
            setFormData({ name: "", phone: "", email: "", message: "" });
        } catch (err) {
            setErrors({ form: err.message });
        }
    };

    return (
        <div id="allPage" style={{ direction: "rtl"}}>

            <Helmet>
                <title>בנימין חסיד</title>

                <link rel="icon" type="image/png" href={logo} />

                <meta name="description" content="בנימין חסיד - עורך דין תעבורה ופלילי. ייצוג משפטי מקצועי בתיקי תעבורה ועבירות פליליות." />
                <meta name="keywords" content="בנימין חסיד, עורך דין תעבורה, עורך דין פלילי, ייצוג משפטי, דיני תעבורה" />
                <meta name="author" content="בנימין חסיד" />

                <meta property="og:title" content="בנימין חסיד - עורך דין תעבורה ופלילי" />
                <meta property="og:description" content="ייצוג משפטי מקצועי בתיקי תעבורה ועבירות פליליות" />
                <meta property="og:image" content={logo} />
                <meta property="og:type" content="website" />
            </Helmet>

            {/* Logo Section */}
            <div className="logo-container">
                <img src={logo} alt="Logo" className="logo-image" />
            </div>

            {/* Hero Section */}
            <section className="hero-section">
                <div className="overlay"></div>
                <div className="hero-content">
                    <h1>ייצוג משפטי מקצועי</h1>
                    <h2>בענייני תעבורה</h2>
                    <p>
                        עם ניסיון רב שנים והצלחה מוכחת, אני מספק ייצוג משפטי מקיף בכל עניין הקשור לתעבורה
                    </p>
                    <a href="#contact">
                        <button className="contact-button">צור קשר</button>
                    </a>

                </div>
            </section>

            {/* About Section */}
            <section className="about-section">
                <div className="about-left">
                    <img className="about-pic" src={pic} alt="בנימין חסיד" />
                    <h1 className={"fH"}>עורך דין בנימין חסיד</h1>
                    <h2 className="tagname">מייסד המשרד ועורך דין לתעבורה ופלילים</h2>
                </div>

                <div className="about-right">
                    <div className="about-intro">
                        <h1>אודות</h1>
                        <div className="gold-bar"></div>
                        <p>
                            עורך דין מומחה בענייני תעבורה, בעל ניסיון רב שנים בייצוג לקוחות בתיקים מורכבים.
                            אני מספק שירות משפטי מקצועי ואישי, תוך התמקדות בהשגת התוצאות הטובות ביותר עבור כל לקוח.
                        </p>
                    </div>

                    <div className="txtBox">
                        <FaUserTie className="txtBox-icon" />
                        <h2 className="titlall">שירותים אישיים ומותאמים</h2>
                        <p>
                            הצוות המקצועי שלנו מתמחה בכל מה שקשור לדיני תעבורה, ומספק שירות אישי ומותאם לכל לקוח.
                            אנו נבחן את המקרה שלכם על פרטיו המדויקים, ונספק לכם את השירות האופטימלי ביותר שיביא לתוצאה הטובה ביותר.
                        </p>
                    </div>

                    <div className="txtBox">
                        <FaGavel className="txtBox-icon" />
                        <h2 className="titlall">ייעוץ משפטי וייצוג בבתי המשפט</h2>
                        <p>
                            עורכי הדין שלנו מספקים יעוץ משפטי איכותי בכל הקשור לדיני תעבורה ומשפט פלילי,
                            עם הבנה מעמיקה של החוקים והתקנות, אנו מסייעים ללקוחותינו להבין ולממש את זכויותיהם.
                            בנוסף, אנו מספקים ייצוג מלא בבתי המשפט ברחבי הארץ כדי להגיע לתוצאה הטובה ביותר.
                        </p>
                    </div>

                    <div className="txtBox">
                        <FaCarSide className="txtBox-icon" />
                        <h2 className="titlall">מגוון רחב של תחומי תעבורה</h2>
                        <p>
                            צוות עורכי הדין במשרדנו מתמחים במגוון הנושאים של דיני התעבורה והפלילי,
                            לנהגים חדשים, צעירים וותיקים - חקירות, מעצרים, נהיגה בשכרות, נהיגה ללא רישיון מתאים,
                            נהיגה במהירות מופרזת, הסעת נוסעים מעל המותר, דו"חות תנועה, ותאונות דרכים עם נזקי רכוש וגוף.
                        </p>
                    </div>
                </div>
            </section>

            {/* Expertise Section */}
            <section className="expertise-section">
                <div className="expertise-header">
                    <h1>תחומי התמחות</h1>
                    <div className="gold-bar"></div>
                    <p>מגוון שירותים משפטיים מקיפים בכל תחומי המשפט התעבורתי</p>
                </div>

                <div className="expertise-cards">
                    <div className="card">
                        <div className="icon"><FaCarCrash /></div>
                        <h2>תאונות דרכים</h2>
                        <p>ייצוג בתיקי תאונות דרכים, תביעות נזיקין ופיצויים</p>
                    </div>

                    <div className="card">
                        <div className="icon"><FaBan /></div>
                        <h2>ביטול רישיונות</h2>
                        <p>ערעור על ביטול או השעיית רישיון נהיגה</p>
                    </div>

                    <div className="card">
                        <div className="icon"><FaFileAlt /></div>
                        <h2>דוחות תעבורה</h2>
                        <p>ערעור וביטול דוחות תעבורה ונקודות</p>
                    </div>

                    <div className="card">
                        <div className="icon"><FaExclamationTriangle /></div>
                        <h2>עבירות פליליות</h2>
                        <p>ייצוג בעבירות תעבורה פליליות חמורות</p>
                    </div>

                    <div className="card">
                        <div className="icon"><FaWineBottle /></div>
                        <h2>נהיגה בשכרות</h2>
                        <p>ייצוג בתיקי נהיגה בשכרות וסמים</p>
                    </div>

                    <div className="card">
                        <div className="icon"><FaKey /></div>
                        <h2>השעיית רישיון</h2>
                        <p>טיפול בהשעיות רישיון והחזרתו</p>
                    </div>
                </div>
            </section>

            {/* Contact Section */}
            <section id={"contact"} className="contact-section">
                <div className="contact-left">
                    <div className="contact-info">
                        <h2>פרטי התקשרות</h2>
                        <p><strong>טלפון:</strong> 054-8410989 </p>
                        <p><strong>אימייל:</strong> lids@binyaminhasid.com </p>
                        <p><strong>כתובת:</strong>שדרות פונוביז' 2 מודיעין עילית</p>
                    </div>
                    <div className="contact-hours">
                        <h2>שעות פעילות</h2>
                        <p><strong>ראשון - חמישי:</strong> 9:00 - 18:00</p>
                        <p><strong>שישי:</strong> 9:00 - 13:00</p>
                        <p><strong>שבת:</strong> סגור</p>
                    </div>
                    <div className="contact__social-map">

                        <div className="social-links__icons">
                            <a
                                href="https://www.facebook.com/bnymyn.hsyd"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-links__icon-button"
                                aria-label="Facebook"
                            >
                                <Facebook className="social-icon"/>
                            </a>
                            <a
                                href="https://wa.me/972548410989?text=שלום%20עורך%20דין%20בנימין%20חסיד!%20ברצוני%20להתייעץ%20בנוגע%20ל..."
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-links__icon-button"
                                aria-label="WhatsApp"
                            >
                                <FontAwesomeIcon icon={faWhatsapp} className="social-icon" />
                            </a>

                            <a
                                href="https://www.waze.com/en/live-map/directions?latlng=31.92421991983004%2C35.04429459464049&navigate=yes"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-links__icon-button"
                                aria-label="Waze"
                            >
                                <FontAwesomeIcon icon={faWaze} className="social-icon" />
                            </a>
                        </div>
                    </div>

                </div>

                <div className="contact-right">
                    <section className={"form-area"}>
                        <h2>צור קשר</h2>
                        <p>השאר פרטים ואחזור אליך בהקדם האפשרי לייעוץ ראשוני ללא התחייבות</p>
                        <form className="contact-form" onSubmit={handleSubmit}>
                            <label>שם מלא *</label>
                            <input type="text" name="name" value={formData.name} onChange={handleChange} />
                            {errors.name && <p className="error">{errors.name}</p>}

                            <label>טלפון *</label>
                            <input type="text" name="phone" value={formData.phone} onChange={handleChange} />
                            {errors.phone && <p className="error">{errors.phone}</p>}

                            <label>אימייל *</label>
                            <input type="email" name="email" value={formData.email} onChange={handleChange} />
                            {errors.email && <p className="error">{errors.email}</p>}

                            <label>הודעה *</label>
                            <textarea name="message" value={formData.message} onChange={handleChange}></textarea>
                            {errors.message && <p className="error">{errors.message}</p>}

                            {errors.form && <p className="error">{errors.form}</p>}
                            {successMsg && <p className="success">{successMsg}</p>}

                            <button type="submit">שלח פנייה</button>
                        </form>
                    </section>
                </div>

            </section>

            {/* Footer Section */}
            <footer className="site-footer">
                <div className="footer-content">
                    <p>© 2025 כל הזכויות שמורות. עורך דין בנימין חסיד</p>
                    <p>פיתוח: נתי פיניאן | 055-9399394</p>
                </div>
            </footer>

        </div>
    );
}
